var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoneNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22266 0.621094H24.1008V20.2858H5.22266V0.621094Z",
    fill: "#A1A3A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5613 7.30298H8.36914V4.94922H20.5613V7.30298Z",
    fill: "#C6C6C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5613 12.0247H8.36914V9.6709H20.5613V12.0247Z",
    fill: "#C6C6C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6619 16.7424H8.36914V14.3887H14.6619V16.7424Z",
    fill: "#C6C6C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.899414 6.52148H3.25318V22.2563H18.988V24.6101H0.899414V6.52148Z",
    fill: "#A1A3A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoneNews);
export default __webpack_public_path__ + "static/media/none-news.07f7409a61defe7c34613c1fffbce869.svg";
export { ForwardRef as ReactComponent };